/*************************************************************************
*
*  Copyright 2022 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

/**
 * Parses search portion of URL into map of query parameters.
 *
 * @param {String} search - Search portion of URL. Optional. If not present,
 *                          uses window.location.search.
 *
 * @returns Map of query parameter values by key
 */
// eslint-disable-next-line import/prefer-default-export
export const getQueryParams = search => {
    const dict = {};
    let i;
    let param;

    const params = (search || window.location.search).substr(1).split("&");

    if (params !== "") {
        for (i = 0; i < params.length; i += 1) {
            param = params[i].split("=");
            if (param.length === 2) {
                dict[param[0]] =
                    decodeURIComponent(param[1].replace(/\+/g, " "));
            }
        }
    }
    return dict;
};
